export const SUPPORTED_LANGUAGES = ['en', 'ja'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export function isSupportedLanguage(
  value: string | null | undefined,
): value is SupportedLanguage {
  return (
    value != null && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
  )
}

const HINT_DISMISSED_KEY = 'portal:language-hint-dismissed'

export function isLanguageHintDismissed(): boolean {
  try {
    return localStorage.getItem(HINT_DISMISSED_KEY) === 'true'
  } catch {
    // localStorage が使えない環境では閉じた状態を保存できないため、ヒントを表示しない
    return true
  }
}

export function dismissLanguageHint(): void {
  try {
    localStorage.setItem(HINT_DISMISSED_KEY, 'true')
  } catch {
    // localStorage が使えない環境では永続化しない
  }
}
